// extracted by mini-css-extract-plugin
module.exports = {"loading":"Loading_loading__bDW8_","animLoader":"Loading_animLoader__ttvkP","pulsIn":"Loading_pulsIn__uxbUp","pulsOut":"Loading_pulsOut__WYOfl"};